import "./static/dafdirect.jpg";
import "./static/dafdirect.png";

import "./give_a_gift.css";
import "./abort_a_banded_bird.css";
